import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import { api, get, post, put } from "../../../utils/api";
import { companyId } from "../../../utils/companyId";
import {
  textError,
  numberError,
  listError,
} from "../../../utils/validationMessage";
import FileField from "../../../Components/Masters/FileField";
import EditDialog from "../../../Components/Common/EditDialog";
import SelectField from "../../../Components/Masters/SelectField";

function AddEquipment(props) {
  const [alreadyEquipment, setAlreadyEquipment] = useState(false);
  const [Units, setUnit] = useState(["MMBTU", "MJ", "GJ"]);
  const [errors, setErrors] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [editDialog, setEditDialog] = useState(false);
  const initialState = {
    industrialProcess: "",
    company: companyId,
    user: "",
    equipment: "",
    country: "Tap to Select",
    brand: "",
    documents: [],
    ratedConsumption: "",
    unit: "Tap to Select",
    remark: "",
  };

  const state = {
    company: companyId,
    industrialProcess: props?.selectedEquipment?.industrialProcess?._id ?? "",

    // facility:props.selectedEquipment?.facility ??"Tap to Select",
    equipment: props.selectedEquipment?.equipment ?? "",
    model: props.selectedEquipment?.model ?? "",
    brand: props.selectedEquipment?.brand ?? "",
    // documents: props.selectedEquipment?.documents ??[],
    ratedConsumption: props.selectedEquipment?.ratedConsumption ?? "",
    unit: props.selectedEquipment?.unit ?? "Tap to Select",
    remark: props.selectedEquipment?.remark ?? "",
  };
  const [options, setOptions] = useState([]);

  const handleExitAgree = () => {
    setFromValue(
      props.selectedEquipment?._id === undefined ? initialState : state
    );
    setFormData2(
      props.selectedEquipment?._id === undefined ? initialState : state
    );
    setUploadedFiles(props.selectedEquipment?.documents ?? []);
    props.setAddEquipment(false);
    setEditDialog(false);
    setErrors({});
  };
  // const handleExitAgree = () => {
  //   setEditDialog(false);
  //   setAddData(false);
  //   setErrors({});
  //   setFormData(initialState);
  //   setFormData2(initialState);
  //   setUploadedFiles(element?.documents || []);
  // };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === formData2[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const [fromValue, setFromValue] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  useEffect(() => {
    const fetchIndustrailProcess = async () => {
      try {
        const equipmentTypeResponse = await get(
          `/master/getAllIndustrialProcess`
        );
        console.log(equipmentTypeResponse.data.data, "d1");
        setOptions(equipmentTypeResponse.data.data);
      } catch (error) {
        console.log("Error fetching facilities:", error);
      }
    };
    fetchIndustrailProcess();
  }, []);

  useEffect(() => {
    setFromValue(state);
    setFormData2(state);
    setUploadedFiles(props.selectedEquipment?.documents ?? []);
    setUploadedFiles(props.selectedEquipment?.documents ?? []);
    setAlreadyEquipment(props.selectedEquipment === null ? false : true);
  }, [props.selectedEquipment]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("nam===e", name, value);
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const {
      model,
      equipment,
      brand,
      industrialProcess,
      ratedConsumption,
      unit,
    } = fromValue;

    // Validate `facilityName`
    // if (!facility || facility.trim()==="Tap to Select"|| facility.trim() === "") {
    //   newErrors.facility = textError;
    // }

    // Validate `user`

    if (!industrialProcess || industrialProcess.trim() === "") {
      newErrors.industrialProcess = "Industrial Process is required.";
    }
    if (!model || model.trim() === "") {
      newErrors.model = textError;
    }

    // Validate `nickname`
    if (!equipment || equipment.trim() === "") {
      newErrors.equipment = textError;
    }

    // Validate `incharge`
    if (!brand || brand.trim() === "") {
      newErrors.brand = textError;
    }
    // if (!ratedConsumption || ratedConsumption.trim() === "" ) {
    //   newErrors.ratedConsumption = numberError;
    // }
    if (
      !ratedConsumption ||
      isNaN(ratedConsumption) ||
      ratedConsumption === "" ||
      ratedConsumption <= 0 ||
      !/^\d*\.?\d*$/.test(ratedConsumption)
    ) {
      newErrors.ratedConsumption = numberError;
    }
    // if (!documents || documents.length === 0) {
    //   newErrors.documents = "At least one document must be uploaded.";
    // }

    // if (uploadedFiles.length === 0) {
    //   // console.log(input.fieldName,uploadedFiles)
    //    newErrors["documents"] = `Please upload Documents`;
    //  }
    if (!unit || unit.trim() === "" || unit.trim() === "Tap to Select") {
      newErrors.unit = listError;
    }

    // Validate `country`

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    const dataToSend = {
      ...fromValue,
      documents: uploadedFiles,
    };

    let method = alreadyEquipment ? put : post;
    let url = alreadyEquipment
      ? `${api}/master/Steam/updateEquipment?Id=${props.selectedEquipment?._id}`
      : `${api}/master/Steam/creatEquipment`;

    await method(url, dataToSend)
      .then((res) => {
        props.setAddEquipment(false);
        props.fetchHeatEquipment();
        handleExitAgree();
        setUploadedFiles([]);
        props.setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setFromValue((pre) => {
          return {
            ...pre,
          };
        });
      })
      .catch((err) => {
        console.log("errrr", err?.response?.data?.message);
        if (err?.response?.data?.message) {
          // props.setsnackOpen({
          //   open: true,
          //   message: err.response.data.message,
          //   severity: "error",
          // });
          setErrors({
            ...errors,
            equipment: "Equipment already exists",
          });
        }
      });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedEquipment?._id === undefined
            ? " Add Steam Equipment"
            : "Edit Steam Equipment"}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Industrial Process
        </Typography>
        <SelectField
          // select
          field="industryProcess"
          variant="outlined"
          options={options}
          value={fromValue.industrialProcess}
          handleChange={handleChange}
          fullWidth
          name="industrialProcess"
          placeholder="Name"
          error={!!errors.industrialProcess} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.equipment ? "#D34040" : undefined },
          }}
        />
        {errors.industrialProcess && (
          <Typography variant="body2" color="#D34040">
            {errors.industrialProcess}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Equipment Name
        </Typography>
        <CustomTextField
          // select
          variant="outlined"
          value={fromValue.equipment}
          onChange={handleChange}
          fullWidth
          name="equipment"
          placeholder="Name"
          error={!!errors.equipment} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.equipment ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.equipment && (
          <Typography variant="body2" color="#D34040">
            {errors.equipment}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Brand
        </Typography>
        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue.brand}
          onChange={handleChange}
          fullWidth
          name="brand"
          placeholder="Name"
          error={!!errors.brand} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.brand ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.brand && (
          <Typography variant="body2" color="#D34040">
            {errors.brand}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Model
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue.model}
          onChange={handleChange}
          fullWidth
          name="model"
          placeholder="Name"
          error={!!errors.model} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.model ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.model && (
          <Typography variant="body2" color="#D34040">
            {errors.model}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Rated Consumption / Hour{" "}
        </Typography>
        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue.ratedConsumption}
          onChange={handleChange}
          fullWidth
          name="ratedConsumption"
          placeholder="1200"
          error={!!errors.ratedConsumption} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.ratedConsumption ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.ratedConsumption && (
          <Typography variant="body2" color="#D34040">
            {errors.ratedConsumption}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Unit
        </Typography>

        <CustomTextField
          select
          variant="outlined"
          value={fromValue.unit}
          onChange={handleChange}
          fullWidth
          name="unit"
          placeholder="Unit"
          error={!!errors.unit} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.unit ? "#D34040" : undefined },
          }}
        >
          <MenuItem
            value={fromValue.unit === "" ? "Tap to Select" : fromValue.unit}
            disabled
          >
            {fromValue.unit === "" ? "Tap to Select" : fromValue.unit}
          </MenuItem>
          {Units.map((item, index) => {
            return (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </CustomTextField>
        {errors.unit && (
          <Typography variant="body2" color="#D34040">
            {errors.unit}
          </Typography>
        )}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          Remark
        </Typography>
        <TextField
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          name="remark"
          value={fromValue.remark}
          onChange={handleChange}
          placeholder="Brief"
        />
        {/* <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          Upload Documents
        </Typography> */}
        <FileField
          title={"Upload Documents"}
          name={"documents"}
          errors={errors["documents"]}
          fileUrls={uploadedFiles}
          progress={uploadProgress["documents"] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
        {/* {loading?<LinearProgress/> :
        <Box
          sx={{
            border: "1px dashed grey",
            borderRadius: 1,
            p: 2,
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <input
            type="file"
            hidden
            id="upload-document"
             onChange={handleFileChange}
            multiple // Allow multiple file selection
          />
          <label htmlFor="upload-document">
          
            <Box display="flex" flexDirection="column" alignItems="center">
              <CloudUploadIcon />
              <Typography>Drop files here or click to upload</Typography>
              <Typography variant="caption">
                1200x800 pixels).
              </Typography>
            </Box>
          </label>
        </Box>} */}

        {/* {errors.documents ? (
          <Typography variant="body2" color="#D34040">
            {errors.documents}
          </Typography>
        ):""
        // fileNames.map((item)=>item).join(',')
        } */}

        {/* <CustomTextField
          //  select
      variant="outlined"
        value={fromValue.outsourceFacility}
      onChange={handleChange}
      fullWidth
      name="outsourceFacility"
      placeholder="Outsource"
    >
    </CustomTextField> */}
        {/* <Box> */}
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>

        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addEquipment}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddEquipment;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
